"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _color = _interopRequireDefault(require("color"));

var _Label = _interopRequireDefault(require("./Label"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ThemedLabel = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ThemedLabel, _Component);

  var _super = _createSuper(ThemedLabel);

  function ThemedLabel() {
    var _this;

    (0, _classCallCheck2["default"])(this, ThemedLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(ThemedLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          otherLabelProps = (0, _objectWithoutProperties2["default"])(_this$props, ["theme"]);
      return /*#__PURE__*/_react["default"].createElement(_Label["default"], (0, _extends2["default"])({
        style: (0, _styling.css)({
          width: otherLabelProps.width,
          padding: "3px 13px"
        }, otherLabelProps.className, otherLabelProps.style)
      }, otherLabelProps, this.labelProps));
    }
  }, {
    key: "labelProps",
    get: function get() {
      var theme = this.props.theme;
      var _this$context$theming = this.context.theming.theme,
          corePrimaryLightest = _this$context$theming.corePrimaryLightest,
          corePrimaryLighter = _this$context$theming.corePrimaryLighter,
          corePrimary = _this$context$theming.corePrimary,
          corePrimaryDark = _this$context$theming.corePrimaryDark,
          textWhite = _this$context$theming.textWhite,
          textLight = _this$context$theming.textLight,
          textDark = _this$context$theming.textDark,
          secondaryLighter = _this$context$theming.secondaryLighter,
          secondaryDark = _this$context$theming.secondaryDark,
          cash = _this$context$theming.cash,
          positiveLighter = _this$context$theming.positiveLighter,
          positive = _this$context$theming.positive,
          positiveDark = _this$context$theming.positiveDark,
          warningLighter = _this$context$theming.warningLighter,
          warningDark = _this$context$theming.warningDark,
          warningDarker = _this$context$theming.warningDarker,
          negativeLighter = _this$context$theming.negativeLighter,
          negativeDark = _this$context$theming.negativeDark,
          surfaceLight = _this$context$theming.surfaceLight,
          surface = _this$context$theming.surface;
      var fontSize = 13;
      var borderRadius = 16; // Reason: these strings are theme ids and are not being shown to the
      // user.

      /* eslint-disable local-rules/unwrapped-i18n */

      switch (theme) {
        case "LightGrey":
          return {
            textColor: textDark,
            backgroundColor: surfaceLight,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "CashGreen":
          return {
            textColor: textWhite,
            backgroundColor: cash,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "Cyan":
          return {
            textColor: textWhite,
            backgroundColor: positive,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "LighterCyan":
          return {
            textColor: positiveDark,
            backgroundColor: positiveLighter,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "WishBlue":
          return {
            textColor: corePrimary,
            backgroundColor: corePrimaryLightest,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "DarkYellow":
          return {
            textColor: textWhite,
            backgroundColor: warningDark,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "DarkRed":
          return {
            textColor: textWhite,
            backgroundColor: negativeDark,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "LightInk":
          return {
            textColor: textWhite,
            backgroundColor: textLight,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "DarkInk":
          return {
            textColor: textWhite,
            backgroundColor: textDark,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "LightWishBlue":
          return {
            textColor: corePrimary,
            backgroundColor: corePrimaryLighter,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "DarkWishBlue":
          return {
            textColor: textWhite,
            backgroundColor: corePrimaryDark,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "DarkPalaceBlue":
          return {
            textColor: secondaryDark,
            backgroundColor: secondaryLighter,
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "Red":
          return {
            textColor: negativeDark,
            backgroundColor: new _color["default"](negativeLighter).alpha(0.5).toString(),
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "Grey":
          return {
            textColor: textLight,
            backgroundColor: new _color["default"](surface).alpha(0.5).toString(),
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        case "Yellow":
          return {
            textColor: warningDarker,
            backgroundColor: new _color["default"](warningLighter).alpha(0.5).toString(),
            fontSize: fontSize,
            borderRadius: borderRadius
          };

        default:
          throw "Unknown theme ".concat(theme);
      }
    }
  }]);
  return ThemedLabel;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  theme: {
    required: true,
    type: "\n        \"LightGrey\"\n        | \"CashGreen\"\n        | \"Cyan\"\n        | \"WishBlue\"\n        | \"DarkYellow\"\n        | \"DarkRed\"\n        | \"LightInk\"\n        | \"DarkInk\"\n        | \"LightWishBlue\"\n        | \"DarkWishBlue\"\n        | \"DarkPalaceBlue\"\n        | \"Red\"\n        | \"Grey\"\n        | \"Yellow\"",
    description: "Color theme for the label"
  }
}, _class3.demoProps = {
  theme: "DarkInk"
}, _class3.demoRender = "\n<ThemedLabel theme=\"DarkInk\">\n  DarkInk\n</ThemedLabel>\n  ", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "labelProps", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "labelProps"), _class2.prototype)), _class2)) || _class;

var _default = ThemedLabel;
exports["default"] = _default;